import React, { useState, useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import LoadingScreen from '../loading/LoadingScreen';
import { getCurrentUser, User } from '../../utils/getData/User';
import UserInfoForm from './UserInfoForm';
import DeliveryHistoryList from './DeliveryHistoryList';

const MyPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [user, setUser] = useState<User>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCurrentUser();
        setUser(response);
      } catch {
        setError("ユーザー情報の取得に失敗しました。ページを読み込みなおして再度お試しください。");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  if (error !== "" || user === undefined) {
    return <p className="text-danger text-center my-4">{error || "ユーザー情報の取得に失敗しました。"}</p>;
  }

  return (
    <>
      <p className="topTitle">マイページ</p>
      <div className="mainSection">
        <Tabs
          id="controlled-tab-mypage"
          defaultActiveKey="userInfo"
          className="mb-3"
          fill
        >
          <Tab eventKey="userInfo" title="登録情報">
            <UserInfoForm user={user} setUser={setUser} />
          </Tab>
          <Tab eventKey="deliveryHistory" title="発送依頼履歴">
            <DeliveryHistoryList />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default MyPage;
